import { render } from "./ChooseFunctionCollaboratorModal.vue?vue&type=template&id=d8143914&scoped=true"
import script from "./ChooseFunctionCollaboratorModal.vue?vue&type=script&lang=js"
export * from "./ChooseFunctionCollaboratorModal.vue?vue&type=script&lang=js"

import "./ChooseFunctionCollaboratorModal.vue?vue&type=style&index=0&id=d8143914&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8143914"]])

export default __exports__